import React from 'react' 

export const Hr: React.FC = () => {
    return <hr />
}